import type { TrackReferenceOrPlaceholder } from '@livekit/components-react';

const participantAvatarKeys = [
  'avatar',
  'avatar_url',
  'avatarUrl',
  'image_url',
  'imageUrl',
  'photo_url',
  'photoUrl',
  'picture',
  'picture_url',
  'pictureUrl',
  'profile_image_url',
  'profileImageUrl',
  'profile_picture',
  'profilePicture',
];

const normalizeAvatarUrl = (value: unknown) => {
  if (typeof value !== 'string') return '';

  const trimmed = value.trim();
  if (!trimmed) return '';

  if (
    /^https?:\/\//i.test(trimmed) ||
    trimmed.startsWith('/') ||
    trimmed.startsWith('data:image/') ||
    trimmed.startsWith('blob:')
  ) {
    return trimmed;
  }

  return '';
};

const getAvatarUrlFromRecord = (value: unknown, depth = 0): string => {
  if (!value || typeof value !== 'object' || depth > 2) return '';

  const record = value as Record<string, unknown>;
  for (const key of participantAvatarKeys) {
    const avatarUrl = normalizeAvatarUrl(record[key]);
    if (avatarUrl) return avatarUrl;
  }

  for (const nestedValue of Object.values(record)) {
    const avatarUrl = getAvatarUrlFromRecord(nestedValue, depth + 1);
    if (avatarUrl) return avatarUrl;
  }

  return '';
};

export const participantAvatarUrl = (
  participant: TrackReferenceOrPlaceholder['participant'],
) => {
  const participantWithProfile = participant as typeof participant & {
    attributes?: Record<string, string | undefined>;
    metadata?: unknown;
  };

  const attributeAvatarUrl = getAvatarUrlFromRecord(
    participantWithProfile.attributes,
  );
  if (attributeAvatarUrl) return attributeAvatarUrl;

  const metadata = participantWithProfile.metadata;
  if (typeof metadata === 'string' && metadata.trim()) {
    try {
      return getAvatarUrlFromRecord(JSON.parse(metadata));
    } catch {
      return '';
    }
  }

  return getAvatarUrlFromRecord(metadata);
};
